import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatSortModule} from "@angular/material/sort";
import {DispositionFilterPipe, SkillFilterPipe, UserFilterPipe} from "./filter.pipes";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatSidenavModule,
        MatSortModule,
        MatRippleModule,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatSidenavModule,
        MatSortModule,
        DispositionFilterPipe,
        UserFilterPipe,
        SkillFilterPipe,
        MatRippleModule,
    ],
    providers: [
        MatDatepickerModule,
    ],
    declarations: [
        DispositionFilterPipe,
        UserFilterPipe,
        SkillFilterPipe
    ]
})
export class SharedModule
{
}
